import licenseModule from '../../license.module';
import $ from 'jquery';

export default licenseModule.component('licenseRenewLicense', {
    template: require('./licenseRenewLicense.component.html'),
    controller: ['LicenseManagementService', licenseRenewLicenseComponent],
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

function licenseRenewLicenseComponent(LicenseManagementService) {
    var vm = this;
    vm.processing = false;

    vm.$onInit = function() {
        vm.data = vm.resolve.data;
        vm.license = {
            payload: '',
            hideButton: false
        };
        vm.navs = [
            {
                label: 'Renew',
                value: 'renew',
                component: 'licenseRenewDetail',
                callback: function(data) {
                    vm.eula = data.eula;
                }
            },
            {
                label: 'License',
                value: 'license',
                component: 'licenseRenewLicenseResult',
                resolve: {
                    license: vm.license
                },
                disabled: true
            }
        ];

        vm.currentWorkflow = vm.navs[0];
        vm.eula = false;

        vm.data = vm.resolve.data;
    };

    vm.cancel = function() {
        if (!vm.processing) {
            vm.dismiss({ $value: 'cancel' });
        }
    };

    vm.next = function() {
        vm.currentWorkflow.disabled = false;
        var nextWorkflow = vm.navs[vm.navs.indexOf(vm.currentWorkflow) + 1];
        if (nextWorkflow.value != 'license') {
            vm.currentWorkflow = nextWorkflow;
        }
        if (nextWorkflow.value == 'license') {
            if (!vm.processing) {
                vm.processing = true;
                LicenseManagementService.getInstanceDetail(vm.data.id).then(
                    function(data) {
                        vm.data.serverProfile = data.payload;

                        LicenseManagementService.renewInstance(
                            vm.data.id,
                            vm.data
                        ).then(
                            function(data) {
                                vm.license.payload = data;
                                vm.currentWorkflow = nextWorkflow;
                                $.each(vm.navs, function(index, value) {
                                    if (value.value != 'license') {
                                        value.disabled = true;
                                        vm.processing = false;
                                    }
                                });
                            },
                            function() {
                                vm.license.payload =
                                    'Failed to generate license. Please try again. If the problem persists, please contact Appspace Support. ';
                                vm.license.hideButton = true;
                                vm.currentWorkflow = nextWorkflow;
                                $.each(vm.navs, function(index, value) {
                                    if (value.value != 'license') {
                                        value.disabled = true;
                                        vm.processing = false;
                                    }
                                });
                            }
                        );
                    }
                );
            }
        }
    };

    vm.ok = function() {
        vm.close({ $value: 'ok' });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-renew-license/licenseRenewLicense.component.js